import Group from 'types/Locations/Group';
import Location from 'types/Locations/Location';
import {
  GetAgroLocationsResponse,
  GetAgroLocationGroupsResponse,
} from 'types/Meteorology/Agro/getAgroLocations';

import {
  GetCities,
  GetCitiesResponse,
} from 'types/Meteorology/Agro/getCities';

export function transformGetAgroLocationsResponse(
  response: GetAgroLocationsResponse,
): Location[] {
  return response.data.map((location) => ({
    id: location.id,
    groupId: location.grupo_id,
    name: location.nome,
    latitude: location.latitude,
    longitude: location.longitude,
    cityId: location.city_id,
    shpPath: location.shp_path,
    createdAt: location.criado_em,
  }));
}

export function transformGetAgroLocationGroupsResponse(
  response: GetAgroLocationGroupsResponse,
): Group[] {
  return response.data.map((group) => ({
    id: group.id,
    description: group.descricao,
    userId: group.user_id,
    createdAt: group.criado_em,
    name: group.nome,
  }));
}

export function transformGetCitiesResponse(
  response: GetCitiesResponse,
): GetCities[] {
  return response.data.map((city) => ({
    shpFilePath: city.shp_file_path,
    id: city.id,
    label: city.label,
    state: city.estado,
    name: city.nome,
  }));
}
